export default "__VITE_ASSET__DDFPPQpg__"